module.exports = __webpack_public_path__ + "static/Car1-4e33e4b0806e23f17233342cc36b2cdf.jpg";